var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81194 1.32711C5.44576 0.619108 6.55424 0.619108 7.18806 1.32711V1.32711C7.51109 1.68794 7.98059 1.88241 8.46414 1.85568V1.85568C9.41296 1.80323 10.1968 2.58704 10.1443 3.53586V3.53586C10.1176 4.01941 10.3121 4.48891 10.6729 4.81194V4.81194C11.3809 5.44576 11.3809 6.55424 10.6729 7.18806V7.18806C10.3121 7.51109 10.1176 7.98059 10.1443 8.46414V8.46414C10.1968 9.41296 9.41296 10.1968 8.46414 10.1443V10.1443C7.98059 10.1176 7.51109 10.3121 7.18806 10.6729V10.6729C6.55424 11.3809 5.44576 11.3809 4.81194 10.6729V10.6729C4.48891 10.3121 4.01941 10.1176 3.53586 10.1443V10.1443C2.58704 10.1968 1.80323 9.41296 1.85568 8.46414V8.46414C1.88241 7.98059 1.68794 7.51109 1.32711 7.18806V7.18806C0.619108 6.55424 0.619108 5.44576 1.32711 4.81194V4.81194C1.68794 4.48891 1.88241 4.01941 1.85568 3.53586V3.53586C1.80323 2.58704 2.58704 1.80323 3.53586 1.85568V1.85568C4.01941 1.88241 4.48891 1.68794 4.81194 1.32711V1.32711Z",
    stroke: "#037D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L5.5 8L8 4.5",
    stroke: "#037D73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCheckIcon);
export default __webpack_public_path__ + "static/media/benefit-check-icon.7fadd5956743fc6f832f199a3ae38bd2.svg";
export { ForwardRef as ReactComponent };